import type { PublicProduct } from "@/types/store";

export const REAL_ESTATE_PROPERTY_TYPES = {
  apartment: "Apartamento",
  house: "Casa",
  townhouse: "Sobrado",
  condo_house: "Casa em condomínio",
  condo_townhouse: "Sobrado em condomínio",
  kitnet: "Kitnet",
  studio: "Studio",
  outbuilding: "Edícula",
  penthouse: "Cobertura",
  duplex: "Duplex",
  triplex: "Triplex",
  flat: "Flat",
  loft: "Loft",
  land: "Terreno",
  small_farm: "Chácara",
  farmstead: "Sítio",
  farm: "Fazenda",
  commercial_room: "Sala comercial",
  store: "Loja / Ponto comercial",
  warehouse: "Galpão",
  commercial_building: "Prédio comercial",
  office: "Escritório",
  storage: "Depósito / Armazém",
  garage: "Garagem",
  commercial: "Comercial",
  rural: "Rural",
  other: "Outro",
} satisfies Record<
  NonNullable<PublicProduct["business_attributes"]["property_type"]>,
  string
>;

export type RealEstateFilters = {
  transaction: "" | "sale" | "rent";
  location: string;
  propertyType: string;
  minPrice: string;
  maxPrice: string;
  query: string;
};

export const EMPTY_REAL_ESTATE_FILTERS: RealEstateFilters = {
  transaction: "",
  location: "",
  propertyType: "",
  minPrice: "",
  maxPrice: "",
  query: "",
};

// Include the city in a neighborhood key so equal names in different cities never merge.
export function getRealEstateLocation(
  product: PublicProduct,
  mode: "neighborhood" | "city",
) {
  const { neighborhood, city } = product.business_attributes;
  return mode === "neighborhood"
    ? [neighborhood?.trim(), city?.trim()].filter(Boolean).join(" · ")
    : city?.trim() || "";
}

export function filterRealEstateProperties(
  products: PublicProduct[],
  filters: RealEstateFilters,
  locationMode: "neighborhood" | "city",
) {
  const query = filters.query.trim().toLocaleLowerCase("pt-BR");
  return products.filter((product) => {
    const attributes = product.business_attributes;
    const price = Number(product.current_price);
    return (
      (!filters.transaction ||
        attributes.transaction_type === filters.transaction) &&
      (!filters.location ||
        getRealEstateLocation(product, locationMode) === filters.location) &&
      (!filters.propertyType ||
        attributes.property_type === filters.propertyType) &&
      (!filters.minPrice ||
        (Number.isFinite(price) && price >= Number(filters.minPrice))) &&
      (!filters.maxPrice ||
        (Number.isFinite(price) && price <= Number(filters.maxPrice))) &&
      (!query ||
        [
          product.name,
          product.reference_code,
          product.short_description,
          attributes.neighborhood,
          attributes.city,
        ]
          .filter(Boolean)
          .join(" ")
          .toLocaleLowerCase("pt-BR")
          .includes(query))
    );
  });
}
